import axios from "axios";
import { API_BASE_URL } from "../util/constants";
import AuthService from "../services/auth";

export default class PlayerService {
  static getPlayers(categoryId) {
    return axios.get(`${API_BASE_URL}/players/${categoryId}`, {
      headers: {
        Authorization: `Bearer ${AuthService.getAuthToken()}`,
      },
    });
  }

  static getCategories() {
    return axios.get(`${API_BASE_URL}/categories`, {
      headers: {
        Authorization: `Bearer ${AuthService.getAuthToken()}`,
      },
    });
  }

  static registerVote(players, categoryId, captcha) {
    return axios.post(
      `${API_BASE_URL}/players/${categoryId}/vote`,
      { players, captcha },
      {
        headers: {
          Authorization: `Bearer ${AuthService.getAuthToken()}`,
        },
      }
    );
  }
}
